import { get } from 'svelte/store';
import * as PROXY from '../../../common/api.js';
import * as PEGASUS from '@smatch/pegasus-api-docs';
import { PRODUCT_STORE } from './store.js';
import { ORGANIZATION_KEY } from '../../authentication/services/store.js';
const DOMAIN = import.meta.env.VITE_DOMAIN;
export * from './types.js';
// Store Functions
const updateStoreBulk = (products) => {
    PRODUCT_STORE.update(data => {
        products.forEach(product => {
            // @ts-expect-error - TODO: Fix Pegasus types
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            data[product._.key] = product;
        });
        return data;
    });
    return products;
};
const updateStore = (response) => {
    if ('_' in response) {
        PRODUCT_STORE.update(data => {
            data[response._.key] = response;
            return data;
        });
    }
    return response;
};
const removeFromStore = (key, response) => {
    if (response === null) {
        PRODUCT_STORE.update(data => {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete data[key];
            return data;
        });
    }
    return response;
};
/* eslint-disable arrow-body-style */
// Filter Products
export const filterProducts = async (parameters = {}) => {
    if (DOMAIN === 'seller') {
        parameters.organizationKey = get(ORGANIZATION_KEY) ?? '';
    }
    return PROXY.handleFilter(PEGASUS.filterProducts, parameters)
        .then(updateStoreBulk);
};
// Fetch Product
export const fetchProduct = async (keys, onError) => {
    return PROXY.handleFetch(PEGASUS.fetchProduct, keys)
        .then(({ data, statusCode }) => {
        if (onError?.(statusCode) === true) {
            return {};
        }
        if (statusCode !== 'STATUS_200') {
            PROXY.handleApiError(statusCode);
            return {};
        }
        updateStore(data);
        return data;
    });
};
// Update Product
export const updateProduct = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateProduct, keys, body)
        .then(updateStore);
};
// Delete Product
export const deleteProduct = async (keys) => {
    return PROXY.handleDelete(PEGASUS.deleteProduct, keys)
        .then(removeFromStore.bind(null, keys.productKey));
};
/* eslint-enable arrow-body-style */ 
